import React from "react";
import { Wrapper } from "../about-her/contents";
import {
  FacebookFilled,
  TwitterCircleFilled,
  InstagramFilled,
} from "@ant-design/icons";

function About() {
  return (
    <>
      <Wrapper>
        <div className="icon-container">
          <span className="icon-bg">
            <FacebookFilled />
          </span>
          <span className="icon-bg">
            <TwitterCircleFilled />
          </span>
          <span className="icon-bg">
            <InstagramFilled />
          </span>
        </div>
        <div className="text-wrap">
          <p>
            <b>I'm Ugbede David.</b> Lorem ipsum dolor sit amet, consectetur
            adipiscing elit. Fusce urna urna, imperdiet et purus ut, ultricies
            sollicitudin arcu. Cras placerat, arcu non faucibus suscipit, ex
            arcu consectetur enim, eu malesuada magna turpis sit amet mauris.
            Nullam nec leo at lorem interdum commodo. Etiam mollis massa in
            mauris lacinia porta. Pellentesque tristique, ante nec dictum
            mollis, felis ligula ullamcorper velit, ac auctor est ipsum vehicula
            ex. Donec eu blandit est, id gravida justo. Maecenas laoreet laoreet
            congue. Cras sit amet vestibulum ligula. Ut nec erat tristique,
            iaculis purus ac, pellentesque mi. Donec ac cursus est. Nunc id
            varius enim, ut tincidunt mi. Integer non est eros. Aliquam ex
            magna, elementum at dignissim vitae, <br /> placerat quis ante.
            Morbi a condimentum quam. Nullam quis quam at ex eleifend feugiat.
            Vivamus lacinia quam quam, ac <br /> viverra turpis pellentesque in.
            Mauris sollicitudin sapien risus, non sagittis velit dictum eget.{" "}
            <br /> Suspendisse velit lacus, pulvinar non ante
          </p>
        </div>
      </Wrapper>
    </>
  );
}

export default About;
